import styled from '@emotion/styled';
import CalendarIcon from 'src/assets/icons/CalendarIcon';
import DatePicker from 'react-datepicker';
import { input } from 'src/assets/colors';
import { fontSize, fontWeight } from 'src/assets/fonts-config';

export const CalendarIconWrapper = styled(CalendarIcon, { label: 'CalendarIconWrapper' })`
    fill: #000;
    height: auto;
    margin-right: 8px;
`;

export const DateInputContainer = styled('div', { label: 'DateInputContainer' })`
    display: flex;

    span[role='alert'] {
        display: none;
    }
`;

export const DatePickerStyled = styled(DatePicker, { label: 'DatePickerStyled' })`
    background-color: ${input.bgColor};
    border-width: 1px;
    border-style: solid;
    border-color: ${input.borderColor};
    color: ${input.txtColor};
    height: 40px;
    line-height: 1.4;
    width: 100%;
    padding: 0 10px 0 10px;
    font-size: ${fontSize.xRegular};
    font-weight: ${fontWeight.medium};
`;

